import { createContext, useContext } from "react";
import { IUseShareContextHook } from "./use-share-context-hook";

export const ShareContext = createContext({} as IUseShareContextHook);

export const useShareContext = () => useContext(ShareContext);
